import { MarketDialog, MarketButton } from '@market/react';
import styles from 'typescript/components/dialog.module.scss';

interface DialogProps {
  dataTestId?: string;
  header?: string;
  body?: string;
  showActivityIndicator?: boolean;
  persistent?: boolean;
  showButton?: boolean;
  buttonText?: string;
  buttonOnClick?: () => void;
}

const Dialog = ({
  dataTestId,
  header = '',
  body = '',
  showActivityIndicator = false,
  persistent = true,
  showButton = false,
  buttonText = '',
  buttonOnClick = () => {
    // Do nothing
  },
}: DialogProps) => {
  return (
    <MarketDialog
      data-testid={dataTestId}
      isLoading={showActivityIndicator}
      persistent={persistent}
    >
      <h2 className={styles.extraMargin}> {header} </h2>
      <div>
        <p>{body}</p>
      </div>
      {showButton && (
        <MarketButton
          rank="primary"
          className={styles.extraMargin}
          onClick={buttonOnClick}
        >
          {buttonText}
        </MarketButton>
      )}
    </MarketDialog>
  );
};

export default Dialog;
